import { z } from 'zod';
import { assertTypes, type NoNewFields } from '../../primitives';

/**
 * An online order in Square (`squareConnectionSchema.ts`), saved with the OrderHub order once its
 * checkout has held the card there, before it takes the payment: the ids that paying, cancelling
 * and refunding it in Square need. Kept apart from the order, so it outlives the order's
 * archiving. Its payment is the order's (`paymentGatewayPaymentId`), and a cancel there is safe to
 * run again, so neither is kept here.
 */
export const squareOrderSchema = z.object({
  orderUuid: z.string(),
  restaurantId: z.string(),
  /** The seller it was placed with, whose access a cancel needs: the venue may link another since. */
  merchantId: z.string(),
  squareOrderId: z.string(),
  /** The run that takes its payment in Square once OrderHub saved the order, and gives up on it. */
  payRunId: z.string(),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
  updatedAt: z.number().optional(),
});
export type SquareOrder = z.output<typeof squareOrderSchema>;

/** Strict schema */
export const squareOrderStrictSchema = squareOrderSchema;

/** Convex schema */
export const squareOrderCvxSchema = squareOrderSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
  updatedAt: z.number(),
});
export type SquareOrderCvx = z.output<typeof squareOrderCvxSchema>;
assertTypes<NoNewFields<SquareOrder, SquareOrderCvx>>();
